import React, { useState } from "react";
import Moment from "moment";
import "moment/locale/es";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
} from "@mui/material";
import ScrollBar from "../../../components/Scrollbar";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { ELIMINAR_COBRO, OBTENER_COBROS } from "../../../graphql/movimientos";
import MovimientosHeader from "../../../components/TableHeader/MovimientosHeader";
import useAuth from "../../../hooks/useAuth";
import Iconify from "../../../components/Iconify";
Moment.locale("es");
const MovimientosList = ({
  headLabel,
  setOpenDialog,
  setBodyDialog,
  setErrorGraph,
  setOpenSnackBar,
  mes,
}) => {
  const { auth } = useAuth();
  let tipo = "";
  auth.role === "admin" ? (tipo = "%") : (tipo = auth.id);

  const { data, loading, error } = useQuery(OBTENER_COBROS, {
    variables: {
      UserId: tipo,
      fecha: mes,
    },
  });

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [eliminarCobro] = useMutation(ELIMINAR_COBRO, {
    update(cache, { data: { eliminarCobro } }) {
      const { obtenerCobros } = cache.readQuery({
        query: OBTENER_COBROS,
        variables: {
          UserId: tipo,

          fecha: mes,
        },
      });
      cache.writeQuery({
        query: OBTENER_COBROS,
        variables: {
          UserId: tipo,

          fecha: mes,
        },
        data: {
          obtenerCobros: [...obtenerCobros, eliminarCobro],
        },
      });
    },
  });

  if (loading) {
    return <h1>Cargando....</h1>;
  }
  const { obtenerCobros } = data;
  //Longitud
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // const {turno} = obtenerCobros
  const handleDeleteRecord = async (e) => {
    try {
      const result = await eliminarCobro({
        variables: {
          id: e,
        },
      });

      setOpenSnackBar(true);
      setErrorGraph({
        mensaje: result.data.eliminarCobro,
        severity: "success",
      });
    } catch (error) {
      setOpenSnackBar(true);
      setErrorGraph({ mensaje: error.message, severity: "error" });
    }
  };

  //Operaciones
  function ccSumarMontos(monto) {
    return `${monto.toFixed(2)}`;
  }

  function subTotal(obtenerCobros) {
    return obtenerCobros
      .map(({ MovimientosModel }) => MovimientosModel.monto)
      .reduce((sum, i) => sum + i, 0);
  }

  function comisionesTotalSum(comisiones) {
    return obtenerCobros
      .map(({ MovimientosModel }) => MovimientosModel.comision)
      .reduce((sum, i) => sum + i, 0);
  }

  //Operaciones
  const ingresSubTotal = subTotal(obtenerCobros);
  const comisionesTotal = comisionesTotalSum(obtenerCobros);

  //console.log(ingresSubTotal - comisionesTotal);

  return (
    <>
      <ScrollBar>
        <TableContainer sx={{ minWidth: 800 }}>
          <Table>
            <MovimientosHeader headLabel={headLabel} />
            <TableBody>
              {obtenerCobros
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => {
                  const {
                    id,
                    turno,
                    fechaTrabajo,
                    fechaReporte,
                    PersonasModel,
                    PlazaModel,
                    UserModel,
                    MovimientosModel,
                  } = row;
                  return (
                    <TableRow hover key={id} tabIndex={-1}>
                      <TableCell>
                        {
                          {
                            1: "Matutino",
                            2: "Vespertino",
                            3: "Diurno",
                          }[turno]
                        }
                      </TableCell>
                      <TableCell>
                        {Moment(fechaTrabajo).format("dddd")}
                      </TableCell>
                      <TableCell>
                        {Moment(fechaTrabajo).format("DD-MMMM-YYYY")}
                      </TableCell>
                      <TableCell>
                        {Moment(fechaReporte).format("DD-MMMM-YYYY")}
                      </TableCell>
                      <TableCell>
                        {PersonasModel.nombre} {PersonasModel.apellidos}
                      </TableCell>
                      <TableCell>{PlazaModel.nombre}</TableCell>
                      <TableCell>$ {MovimientosModel.monto}</TableCell>
                      <TableCell>${MovimientosModel.comision}</TableCell>
                      <TableCell>${MovimientosModel.neto}</TableCell>
                      <TableCell>{UserModel?.name}</TableCell>
                      <TableCell>
                        <Button
                          value={id}
                          onClick={(e) => {
                            handleDeleteRecord(id);
                          }}
                          color="error"
                          startIcon={<Iconify icon="eva:close-outline" />}
                        ></Button>
                      </TableCell>
                    </TableRow>
                  );
                })}
              <TableRow>
                <TableCell colSpan={6}></TableCell>
                <TableCell>$ {ingresSubTotal}</TableCell>
                <TableCell>$ {comisionesTotal}</TableCell>
                <TableCell>$ {ingresSubTotal - comisionesTotal}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </ScrollBar>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        page={page}
        count={obtenerCobros.length}
        rowsPerPage={rowsPerPage}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  );
};

export default MovimientosList;
